export const calculatePercentageDiscountedPrice = (price: number, percentage: number) => {
  if (percentage === 0) return price

  return price - (price * percentage) / 100
}
